import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentfortuljapurtrip() {



const cardData =
{
  keyword: 'Mini Bus on Rent for Tuljapur Trip',
  heading: 'Sanavi Travels: Mini Bus on Rent for Tuljapur Trip',
  headingDescription: 'Sanavi Travels provides reliable and comfortable Mini Bus on Rent for Tuljapur Trip, ideal for devotees, families, corporate groups, wedding rituals, and group travelers visiting the sacred Tulja Bhavani Temple. Our well-maintained AC and Non-AC mini buses ensure safe, smooth, and convenient travel with experienced drivers, flexible pickup points, and transparent pricing, making Tuljapur darshan journeys peaceful and well-organized.',

  top: 'Important Places & Travel Highlights for Tuljapur Trip',

  "topPlaces": [
    {
      "title": "Tulja Bhavani Temple",
      "description": "Tulja Bhavani Temple is one of Maharashtra’s most revered Shakti Peeths, attracting lakhs of devotees throughout the year. Traveling by mini bus allows groups to reach the temple together in comfort, reducing travel fatigue and ensuring timely darshan. Mini buses are especially suitable for early morning aartis and festival visits, offering relaxed seating, safe handling of temple traffic, and convenient drop-off points close to the temple area."
    },
    {
      "title": "Tuljapur Town Area",
      "description": "Tuljapur town offers essential amenities such as lodging, food stalls, and local markets for devotees. Mini bus travel helps groups move easily between accommodation, temple visits, and nearby locations without the stress of coordinating multiple vehicles, ensuring smooth group movement."
    },
    {
      "title": "Festival & Navratri Yatra Routes",
      "description": "During Navratri and other major festivals, Tuljapur experiences heavy pilgrim traffic. Mini buses provide organized and manageable group transport, helping travelers avoid congestion, maintain group discipline, and enjoy a safer, more comfortable pilgrimage experience."
    },
    {
      "title": "Family & Senior Citizen Darshan Trips",
      "description": "Mini buses are ideal for families and senior citizens visiting Tuljapur, offering easy boarding, stable seating, and smooth suspension. This ensures a stress-free journey, allowing elderly devotees and children to travel safely and comfortably."
    },
    {
      "title": "Group Pilgrimage & Bhajan Mandal Travel",
      "description": "Bhajan mandals, community groups, and religious organizations often prefer mini buses for Tuljapur trips, as they allow everyone to travel together, sing bhajans, and maintain spiritual unity throughout the journey."
    },
    {
      "title": "Wedding & Ritual Temple Visits",
      "description": "Many families visit Tuljapur for wedding-related rituals and blessings. Mini bus rentals provide dignified, coordinated, and comfortable travel for family members, ensuring timely arrival and a peaceful spiritual experience."
    },
    {
      "title": "Corporate Spiritual & Team Outings",
      "description": "Corporate groups organizing spiritual retreats or team outings to Tuljapur benefit from mini bus travel that ensures punctuality, comfort, and professional transport management."
    },
    {
      "title": "Overnight & One-Day Tuljapur Tours",
      "description": "Mini buses support flexible travel plans, whether for one-day darshan trips or overnight stays, allowing groups to travel comfortably at their own pace."
    }
  ],

  "services": [
    {
      "name": "Mini Bus on Rent for Tuljapur Trip",
      "description": "Sanavi Travels offers dedicated mini bus rental services for Tuljapur trips, designed to provide a smooth, safe, and spiritually comfortable journey. This service is ideal for families, devotees, bhajan mandals, wedding groups, and corporate teams traveling together. With spacious seating, controlled driving, and reliable scheduling, mini bus travel ensures stress-free group coordination, reduced travel fatigue, and a peaceful pilgrimage experience from pickup to drop."
    },
    {
      "name": "AC Mini Bus Tuljapur",
      "description": "AC mini buses are perfect for long-distance Tuljapur travel, especially during summer seasons. These buses provide cool interiors, comfortable seating, and smooth suspension, ensuring passengers remain relaxed and refreshed throughout the journey."
    },
    {
      "name": "Non AC Mini Bus Hire Tuljapur",
      "description": "Non-AC mini buses offer a cost-effective option while maintaining comfort and safety. Suitable for budget-conscious groups, they provide spacious seating and reliable performance for pilgrimage travel."
    },
    {
      "name": "12 Seater Mini Bus Tuljapur",
      "description": "12 seater mini buses are ideal for small families and close-knit groups, offering flexibility, easy maneuverability, and comfortable travel for Tuljapur darshan."
    },
    {
      "name": "16 Seater Mini Bus Tuljapur",
      "description": "16 seater mini buses are suitable for medium-sized groups, balancing seating capacity and comfort for family trips, bhajan groups, and small corporate outings."
    },
    {
      "name": "20 Seater Mini Bus Tuljapur",
      "description": "20 seater mini buses are perfect for larger pilgrimage groups, allowing everyone to travel together comfortably with ample luggage space and organized seating."
    },
    {
      "name": "Luxury Mini Bus Tuljapur",
      "description": "Luxury mini buses offer premium interiors, pushback seats, and enhanced comfort, making them ideal for VIP pilgrims, wedding rituals, and corporate spiritual trips."
    },
    {
      "name": "Mini Bus for Family Tuljapur",
      "description": "Family-oriented mini bus services ensure safe, comfortable, and coordinated travel for all age groups, including elders and children."
    },
    {
      "name": "Mini Bus for Corporate Tuljapur",
      "description": "Corporate mini bus rentals support organized spiritual outings, team-building trips, and company pilgrimages with punctual and professional transport."
    },
    {
      "name": "Mini Bus for Group Tuljapur",
      "description": "Group mini bus services allow religious and social groups to travel together, ensuring unity, punctuality, and a peaceful travel experience."
    },
    {
      "name": "Affordable Mini Bus Rental Tuljapur",
      "description": "Affordable mini bus packages offer transparent pricing and dependable service without compromising comfort or safety."
    },
    {
      "name": "Best Mini Bus Service Tuljapur",
      "description": "Sanavi Travels is trusted for providing reliable and well-managed mini bus services for Tuljapur trips."
    },
    {
      "name": "Mini Bus with Driver Tuljapur",
      "description": "All mini bus rentals include experienced drivers familiar with Tuljapur routes, temple access points, and pilgrimage traffic conditions."
    },
    {
      "name": "Mini Bus for Picnic Tuljapur",
      "description": "Mini buses also support leisure-style picnic trips combined with temple visits, offering relaxed and enjoyable group travel."
    },
    {
      "name": "Mini Bus for Wedding Tuljapur",
      "description": "Wedding-related temple visits become comfortable and organized with mini bus rentals that ensure timely and dignified travel."
    }
  ],

  "tableData": [
    ["Mini Bus Tuljapur", "AC Mini Bus"],
    ["Non AC Mini Bus", "12 Seater Mini Bus"],
    ["16 Seater Mini Bus", "20 Seater Mini Bus"],
    ["Family Travel", "Group Travel"],
    ["Corporate Trip", "Wedding Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Comfortable Group Travel", "WhyChoosedescription": "Mini buses ensure relaxed and stress-free pilgrimage journeys." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Drivers are well-versed with Tuljapur routes and temple timings." },
    { "WhyChooseheading": "Clean & Maintained Vehicles", "WhyChoosedescription": "All mini buses are cleaned and serviced regularly." },
    { "WhyChooseheading": "Flexible Pickup Options", "WhyChoosedescription": "Pickup points can be customized for group convenience." },
    { "WhyChooseheading": "Multiple Seating Options", "WhyChoosedescription": "12, 16, and 20 seater mini buses available." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing with no hidden charges." },
    { "WhyChooseheading": "Ideal for Pilgrimages", "WhyChoosedescription": "Designed specifically for devotional and yatra travel." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for dependable pilgrimage transport." }
  ]
};

const faqData = [
  { question: 'Do you provide mini buses for Tuljapur trips?', answer: 'Yes, Sanavi Travels offers mini bus rentals for Tuljapur darshan trips.' },
  { question: 'Are AC mini buses available?', answer: 'Yes, both AC and Non-AC mini buses are available.' },
  { question: 'Is this service suitable for families?', answer: 'Yes, mini buses are ideal for family and group travel.' },
  { question: 'Do you provide drivers?', answer: 'Yes, all rentals include experienced drivers.' },
  { question: 'What seating options are available?', answer: '12, 16, and 20 seater mini buses are available.' },
  { question: 'Can we plan a one-day Tuljapur trip?', answer: 'Yes, one-day and overnight trips are supported.' },
  { question: 'Are buses sanitized before travel?', answer: 'Yes, all vehicles are cleaned and sanitized.' },
  { question: 'Is Tuljapur considered outstation travel?', answer: 'Yes, Tuljapur trips are handled as outstation travel.' },
  { question: 'Can pickup locations be customized?', answer: 'Yes, pickup points can be customized as per group needs.' },
  { question: 'Is this service suitable during Navratri?', answer: 'Yes, we provide services during Navratri and peak yatra seasons.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Pawar',
    feedback: 'Very comfortable mini bus service for Tuljapur darshan. Smooth and peaceful journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Rekha Deshmukh',
    feedback: 'Sanavi Travels managed our Tuljapur trip perfectly. Clean bus and polite driver.',
    rating: 5
  }
];





































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent for Tuljapur Trip - Sanavi Travels",
  "description": "Sanavi Travels offers mini buses on rent for Tuljapur trips for family outings, corporate travel, group tours, picnics, and weddings. AC and Non-AC mini buses in 12-seater, 16-seater, and 20-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};




  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Mini Bus on Rent for Tuljapur Trip | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book mini buses for Tuljapur trips with Sanavi Travels. AC & Non-AC 12-seater, 16-seater, and 20-seater mini buses for family outings, corporate travel, group tours, picnics, and weddings with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/270.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentfortuljapurtrip;